if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.isModalForm = this.getAttribute('data-modal-form') === "true";
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();

      const form = this.querySelector('form');

      this.elements.input.value = event.currentTarget.dataset.value;

      if (this.isModalForm) {
        this.emitEvent(event);
        this.updateButton(event);
        this.closeSelector(event);
      }

      if (form && !this.isModalForm) form.submit();
    }

    emitEvent({ currentTarget: target }) {
      publish(PUB_SUB_EVENTS.locationChange, {
        type: this.elements.input.name.replace("_code", ""),
        value: target.dataset.value
      });
    }

    updateButton({ currentTarget: target }) {
      const flagCode = target.dataset.value === 'en' ? 'gb' : target.dataset.value;
      const url = `https://raw.githubusercontent.com/Fostr-io/fostr_assets/main/country_flags/circle/${flagCode.toLowerCase()}-circle.svg`;
      const newLabel = target.dataset.country ? target.dataset.country : target.dataset.language;
      const flag = this.elements.button.querySelector('.js-flag-icon image');
      const currency = this.elements.button.querySelector('.js-localization-currency');
      const label = this.elements.button.querySelector('.js-localization-label');

      if (currency) currency.innerText = target.dataset.currency;

      flag.href.baseVal = url;
      label.innerText = newLabel;
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}
